import { defineComponent } from 'vue';
import { formatSize, isTruePlayFormat, parseTime, toast } from '@remote/utils';
import { mapState, mapGetters, useStore } from 'vuex';
import { USER_DOWNLOAD_URL } from '@remote/constant';
import { getIconFromMineType } from '@remote/utils/static-icons';
import MeetIcon from '@remote/assets/img/meet-download-icon@3x.svg';
import SpeedTackIcon from '@remote/assets/img/speed-tack-icon@3x.png';
import debounce from 'lodash/debounce';
import { stat } from '@remote/utils/stat';
import { categorizeByFileExtension, getExtensionFromFilename } from '@shared/utils/file';
export default defineComponent({
  name: 'FileItem',
  props: ['id', 'load'],
  setup() {
    return {
      store: useStore()
    };
  },
  data() {
    return {
      iShowHuddle: true,
      MeetIcon,
      SpeedTackIcon
    };
  },
  computed: {
    ...mapState(['all', 'isSelect', 'taskType', 'tasks', 'filePopTaskID', 'huddleNum', 'teamTaskId', 'showLastCount', 'parentIds', 'isMiniProgram']),
    ...mapGetters(['curList', 'isVip', 'vipType', 'runningList', 'isYSvip', 'showVip', 'appCanPlay']),
    file() {
      return this.all[this.id];
    },
    phase() {
      return this.file.phase;
    },
    spec() {
      const spec = (this.file.params.spec || '').match(/(delete|pause|running)/);
      return spec && this.phase !== 'PHASE_TYPE_ERROR' ? spec[0] : '';
    },
    size() {
      if (this.taskType === 'file' && this.file.kind === 'drive#folder') return '';
      return this.file.file_size !== '0' ? formatSize(this.file.file_size || Number(this.file.size)) : '未知大小';
    },
    iconLink() {
      return this.file.icon_link || getIconFromMineType(this.file.mime_type);
    }
  },
  watch: {
    phase(val, oVal) {
      if (val !== oVal && val === 'PHASE_TYPE_RUNNING' && this.huddleNum > 0 && this.file.type === USER_DOWNLOAD_URL && !this.isYSvip) {
        setTimeout(() => this.store.dispatch('checkHuddle', this.file), 1000);
      }
    }
  },
  methods: {
    parseTime,
    formatSize,
    handleSelect: debounce(async function (e) {
      if (this.file.kind === 'drive#file') {
        var _this$file, _this$file$name, _this$file2, _this$file$name2, _this$file3, _this$file4, _this$file5, _this$file6, _this$all$this$filePo, _this$all$this$filePo2;
        const isVideo = ((_this$file = this.file) === null || _this$file === void 0 || (_this$file = _this$file.mime_type) === null || _this$file === void 0 ? void 0 : _this$file.includes('video')) || isTruePlayFormat((_this$file$name = (_this$file2 = this.file) === null || _this$file2 === void 0 ? void 0 : _this$file2.name) !== null && _this$file$name !== void 0 ? _this$file$name : '');
        stat({
          action: 'complete_file_play_btn_click',
          data: {
            tab: this.taskType === 'ing' ? 'downloading' : 'complete',
            type: categorizeByFileExtension(getExtensionFromFilename((_this$file$name2 = (_this$file3 = this.file) === null || _this$file3 === void 0 ? void 0 : _this$file3.name) !== null && _this$file$name2 !== void 0 ? _this$file$name2 : '')),
            gcid: (_this$file4 = this.file) === null || _this$file4 === void 0 ? void 0 : _this$file4.hash,
            info_hash: (_this$file5 = this.file) === null || _this$file5 === void 0 || (_this$file5 = _this$file5.params) === null || _this$file5 === void 0 ? void 0 : _this$file5.info_hash,
            url: (_this$file6 = this.file) === null || _this$file6 === void 0 || (_this$file6 = _this$file6.params) === null || _this$file6 === void 0 ? void 0 : _this$file6.url,
            task_name: (_this$all$this$filePo = this.all[this.filePopTaskID]) === null || _this$all$this$filePo === void 0 ? void 0 : _this$all$this$filePo.name,
            task_size: (_this$all$this$filePo2 = this.all[this.filePopTaskID]) === null || _this$all$this$filePo2 === void 0 ? void 0 : _this$all$this$filePo2.file_size,
            file_name: this.file.name,
            file_size: this.file.file_size,
            file_extension: this.file.file_extension
          }
        });
        return this.$store.dispatch('getFileInfo', {
          id: this.file.id,
          usage: isVideo ? 2 : 0,
          theme: 'light',
          action_from: 'completed',
          scene: 'download_list'
        }).then(() => {
          this.store.commit('update', {
            showFilePop: false,
            filePopTaskID: '',
            parentIds: []
          });
        }).catch(() => {
          if (this.phase === 'PHASE_TYPE_COMPLETE') {
            toast('打开失败，请检查文件是否存在');
          } else if (['PHASE_TYPE_RUNNING', 'PHASE_TYPE_PAUSED'].includes(this.phase)) {
            toast('该任务尚未有已完成下载的文件，请稍后重试');
          }
        });
      } else {
        this.store.commit('update', {
          files: []
        });
        this.load(this.file);
      }
    }, 500, {
      leading: true,
      trailing: false
    })
  }
});